import { NEW_ENTITY } from '@snowit/constants';

/** Same rule as the backend Tag model: the tag is the document id, lowercase kebab-case. */
export const TAG_ID_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/**
 * `all` is reserved by the backend as the "all tags" filter value, `new` by the
 * dashboard as the route of the creation form (`/tags/new`).
 */
const RESERVED_TAG_IDS: string[] = ['all', NEW_ENTITY];

export const isValidTagId = (id: string | undefined): id is string =>
  Boolean(id) && TAG_ID_PATTERN.test(id!) && !RESERVED_TAG_IDS.includes(id!);

/**
 * Forces the input towards a kebab-case id while typing: lowercase, every
 * non-alphanumeric character becomes a dash, without repeated or leading dashes.
 * A trailing dash is kept, so the next word can still be typed.
 */
export const normalizeTagId = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+/, '');
